'use client'

import React from 'react'
import { GlassCard } from './components/ui/GlassCard'
import { Button } from './components/ui/Button'
import Link from 'next/link'
import { ArrowRight, Layers, Leaf, Beaker, FileCheck, Tag, ShieldCheck } from 'lucide-react'
import { HolographicTerminal } from './components/HolographicTerminal'

export function OverviewSection() {
  return (
    <div className="relative w-full min-h-full flex items-center">
      <div className="container mx-auto px-8 lg:px-12 max-w-7xl">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12 lg:gap-16">
          {/* Left Content - Better vertical centering and spacing */}
          <div className="flex-1 space-y-8 max-w-2xl py-8 lg:py-12 mt-0">
            {/* Trust Badge - Better positioning */}
            <div className="flex justify-center lg:justify-start">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full backdrop-blur-xl bg-white/[0.02] border border-eskerium-blue/30 pill-border-glow-gold">
                <ShieldCheck className="w-5 h-5 text-eskerium-blue" />
                <span className="text-md font-medium bg-gradient-to-r from-eskerium-blue to-blue-400 bg-clip-text text-transparent">
                  Direct-to-Lab
                </span>
              </div>
            </div>
            
            {/* Main Heading - Better spaced with original font sizes */}
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.2] text-center lg:text-left">
              <span className="block bg-gradient-to-r from-white to-slate-300 bg-clip-text text-transparent">
                Premium Hemp
              </span>
              <span className="block mt-2 italic-accent bg-gradient-to-r from-eskerium-gold via-yellow-300 to-eskerium-gold bg-clip-text text-transparent">
                Live Resin
              </span>
              <span className="block mt-4 bg-gradient-to-r from-white to-slate-300 bg-clip-text text-transparent">
                Priced to Scale
              </span>
            </h1>
            
            {/* Description - Better spacing and size */}
            <p className="text-lg text-white/70 leading-relaxed text-center lg:text-left max-w-lg mx-auto lg:mx-0">
              We don't just supply ingredients—we collaborate with your team.
              Your success is our success!
            </p>
            
            {/* Quality Badges Grid - Better spacing */}
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4 pt-4">
              {[
                { icon: Layers, title: "Built to scale", desc: "Inventory depth to match your growth—no stockouts." },
                { icon: Leaf, title: "Seed to sale", desc: "Vertically integrated. No middlemen. Direct-to-lab." },
                { icon: Beaker, title: "Richer chemistry", desc: "30+ active compounds for nuanced profiles & entourage effect." },
                { icon: FileCheck, title: "Verified", desc: "Full-panel COAs, every time." },
                { icon: Tag, title: "Fair pricing", desc: "Premium quality without the premium markup." },
                { icon: Leaf, title: "Sustainable", desc: "Eco-friendly practices from seed to delivery." }
              ].map((item, index) => (
                <div key={index} className="relative card-glass gradient-border edge-internal-glow edge-internal-glow-blue edge-internal-glow-soft p-4 hover:shadow-elev-2 hover:-translate-y-0.5 transition-all duration-300 ease-gentle h-full min-h-[140px]">
                  <div className="relative z-[1] flex flex-col items-start gap-2 h-full">
                    <div className="p-2 rounded-lg bg-gradient-to-br from-eskerium-gold/20 to-eskerium-gold/10">
                      <item.icon className="w-5 h-5 text-eskerium-gold icon-edge-glow" />
                    </div>
                    <h4 className="font-semibold text-sm text-white">{item.title}</h4>
                    <p className="text-xs text-white/60 leading-relaxed flex-1">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>

          </div>
          
          {/* Right Content - Terminal with better alignment */}
          <div className="flex-1 max-w-xl lg:max-w-2xl self-center">
            <HolographicTerminal />
          </div>
        </div>
      </div>
    </div>
  )
}